// The deliverable drawers' shell: a Specra overlay drawer (width lg) that is
// open whenever it is mounted. The URL param that mounts it is the open
// state, so closing is removing the param (drawerParams), never local state.
import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraOverlayDrawer } from '@mono/ui-components';
export function CmDrawer({ title, description, eyebrow, headerActions, onClose, testId, footer, footerProps, busy = false, children }) {
    const common = {
        open: true,
        width: 'lg',
        title,
        description,
        eyebrow,
        headerActions,
        testId,
        onOpenChange: (next)=>{
            if (!next && !busy) onClose();
        }
    };
    return footerProps ? /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
        ...common,
        footerProps: footerProps,
        children: children
    }) : /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
        ...common,
        footer: footer,
        children: children
    });
}
